import React from 'react';
import { Card } from './ui/card';

const About = () => {
  return (
    <section id="about" className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            About <span className="text-teal-500">Me</span>
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1 space-y-6">
            <Card className="p-8 bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm border-slate-200 dark:border-slate-700 shadow-xl">
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">
                Profile Summary
              </h3>
              <p className="text-slate-600 dark:text-slate-300 leading-relaxed text-lg">
                Computer Science student with strong knowledge of Java and Python, and hands-on experience in Data Structures and Algorithms (DSA). Skilled in NumPy and Pandas for data analysis and preprocessing, with a growing interest in Artificial Intelligence and Machine Learning (AI/ML). Experienced in frontend development, building user-friendly interfaces for applications. Passionate about learning new technologies, solving problems efficiently, and applying technical skills to real-world projects.
              </p>
            </Card>

            <Card className="p-8 bg-white/50 dark:bg-slate-800/50 backdrop-blur-sm border-slate-200 dark:border-slate-700 shadow-xl">
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-4">
                Quick Facts
              </h3>
              <div className="space-y-3 text-slate-600 dark:text-slate-300">
                <div className="flex justify-between">
                  <span className="font-medium">Location:</span>
                  <span>Tirupati, Andhra Pradesh</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Email:</span>
                  <span className="text-teal-500">chandanavadathala@gmail.com</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Phone:</span>
                  <span>9392159190</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Availability:</span>
                  <span className="text-green-500 font-medium">Open to Opportunities</span>
                </div>
              </div>
            </Card>
          </div>

          <div className="order-1 md:order-2 flex justify-center">
            <div className="relative w-80 h-80 rounded-2xl overflow-hidden shadow-2xl hover:scale-105 transition-transform duration-300">
              <img
                src="https://customer-assets.emergentagent.com/job_chandana-portfolio-1/artifacts/msaqx5e3_pic.jpg"
                alt="Chandana Vadathala"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-500/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
